var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoChartCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.87003V3.89003C13 4.56003 13.45 5.12003 14.08 5.32003C16.93 6.21003 19 8.86003 19 12C19 12.52 18.94 13.01 18.83 13.49C18.69 14.13 18.95 14.79 19.52 15.13L19.53 15.14C20.39 15.64 21.51 15.19 21.74 14.23C21.91 13.51 22 12.76 22 12C22 7.50003 19.02 3.68003 14.92 2.43003C13.97 2.14003 13 2.87003 13 3.87003ZM10.94 18.92C7.95001 18.49 5.52001 16.06 5.08001 13.08C4.54001 9.48003 6.74001 6.31003 9.91001 5.32003C10.55 5.13003 11 4.56003 11 3.89003V3.87003C11 2.87003 10.03 2.14003 9.07 2.43003C4.56 3.81003 1.41001 8.29003 2.09001 13.39C2.68001 17.77 6.22001 21.31 10.6 21.9C13.74 22.32 16.64 21.29 18.73 19.37C19.47 18.69 19.34 17.48 18.47 16.98C17.89 16.64 17.17 16.75 16.67 17.2C15.2 18.54 13.16 19.25 10.94 18.92Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChartCircle);
export default __webpack_public_path__ + "static/media/ico-chart-circle.d12848c6749f3676f2a9d377b0ec17f5.svg";
export { ForwardRef as ReactComponent };